export default (element, variable) => getComputedStyle(element).getPropertyValue(`--${variable}`);
